import styled, { css } from 'styled-components';

interface IVisible {
  $visible: boolean;
}

/**
 * Vidro escuro dos controles. Precisa ser legível sobre qualquer quadro do
 * vídeo — daí o fundo próprio, e não a paleta clara do resto do card.
 */
const controlSurface = css`
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
  color: #fff;
  border: none;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
  cursor: pointer;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

export const CenterButton = styled.button<IVisible>`
  ${controlSurface}
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
    scale(${({ $visible }) => ($visible ? 1 : 0.8)});
  width: 3.4rem;
  height: 3.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transition:
    opacity 0.22s ease,
    transform 0.22s ease;

  > svg {
    /* O triângulo do play parece descentralizado quando centralizado de fato. */
    margin-left: 0.14rem;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const MuteButton = styled.button`
  ${controlSurface}
  position: absolute;
  right: 0.7rem;
  bottom: 0.9rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 4;

  /* Sempre visível, e não só no hover: é o único caminho para o som, e no
     celular não existe hover. */
  &:focus-visible {
    outline: 2px solid #1e88e5;
    outline-offset: 2px;
  }
`;

export const TimeBadge = styled.span`
  ${controlSurface}
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  z-index: 4;
  padding: 0.18rem 0.42rem;
  border-radius: 0.3rem;
  font-family: 'RedHatDisplay-Medium';
  font-size: 0.7rem;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  pointer-events: none;
`;

/**
 * Faixa fina no rodapé. Cresce no hover para virar alvo de clique confortável
 * sem roubar área do vídeo enquanto ninguém está mexendo.
 */
export const ProgressTrack = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.9rem;
  display: flex;
  align-items: flex-end;
  z-index: 4;
  cursor: pointer;
  touch-action: none;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 0.2rem;
    background: rgba(255, 255, 255, 0.28);
    transition: height 0.16s ease;
  }

  &:hover::before,
  &:focus-within::before {
    height: 0.35rem;
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      transition: none;
    }
  }
`;

export const ProgressFill = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  height: 0.2rem;
  background: #1e88e5;
  transition: height 0.16s ease;
  pointer-events: none;

  ${ProgressTrack}:hover &,
  ${ProgressTrack}:focus-within & {
    height: 0.35rem;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
